import React from "react"
import Img from "gatsby-image"
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode"
import "./guideline-card.scss"

const GuidelineCard = (props) => {
    const { homeLink } = useHomeLinkMode();
    return (
        <>
            {props.guideline && props.guideline.length > 0 ? props.guideline.map(guideline => 
            <div className="f-card-product f-card-guideline" onClick={(e)=> { e.preventDefault(); window.location.href = homeLink + guideline.redireccion}}>
                <Img className="f-img-guideline" fluid={guideline.imagenes[0].fluid} alt={guideline.imagenes[0].description ? guideline.imagenes[0].description : "image"} />
            </div>
            ) :
            <div className="f-card-product f-card-guideline" onClick={(e)=> { e.preventDefault(); window.location.href = homeLink + props.guideline.redireccion}}>
                <Img className="f-img-guideline" fluid={props.guideline.imagenes[0].fluid} alt={props.guideline.imagenes[0].description ? props.guideline.imagenes[0].description : "image"} />
            </div>
            }
        </>
    )
}

export default GuidelineCard
